export const partners = [
    {
        title: 'Base',
        icon: '/assets/images/partners/Base.svg',
    },
    {
        title: 'Binance',
        icon: '/assets/images/partners/Binance.svg',
    },
    {
        title: 'Bitcoin',
        icon: '/assets/images/partners/Bitcoin.svg',
    },
    {
        title: 'Bitlayer',
        icon: '/assets/images/partners/Bitlayer.svg',
    },
    {
        title: 'BNB Chain',
        icon: '/assets/images/partners/BNB Chain.svg',
    },
    {
        title: 'Casper',
        icon: '/assets/images/partners/Casper.svg',
    },
    {
        title: 'Circle',
        icon: '/assets/images/partners/Circle.svg',
    },
    {
        title: 'Coinbase',
        icon: '/assets/images/partners/Coinbase.svg',
    },
    {
        title: 'Core Chain',
        icon: '/assets/images/partners/Core Chain.svg',
    },
    {
        title: 'Crossmint',
        icon: '/assets/images/partners/Crossmint.svg',
    },
    {
        title: 'Hedera',
        icon: '/assets/images/partners/Hedera.svg',
    },
    {
        title: 'Linea',
        icon: '/assets/images/partners/Linea.svg',
    },
    {
        title: 'MEW',
        icon: '/assets/images/partners/MEW.svg',
    },
    {
        title: 'Metamask',
        icon: '/assets/images/partners/Metamask.svg',
    },
    {
        title: 'Near',
        icon: '/assets/images/partners/Near.svg',
    },
    {
        title: 'Paymob',
        icon: '/assets/images/partners/Paymob.svg',
    },
    {
        title: 'Phantom',
        icon: '/assets/images/partners/Phantom.svg',
    },
    {
        title: 'Polygon',
        icon: '/assets/images/partners/Polygon.svg',
    },
    {
        title: 'Rainbow',
        icon: '/assets/images/partners/Rainbow.svg',
    },
    {
        title: 'Redbelly',
        icon: '/assets/images/partners/Redbelly.svg',
    },
    {
        title: 'Shib',
        icon: '/assets/images/partners/Shib.svg',
    },
    {
        title: 'Skale',
        icon: '/assets/images/partners/Skale.svg',
    },
    {
        title: 'Stacks',
        icon: '/assets/images/partners/Stacks.svg',
    },
    {
        title: 'Stripe',
        icon: '/assets/images/partners/Stripe.svg',
    },
    {
        title: 'Tether',
        icon: '/assets/images/partners/Tether.svg',
    },
    {
        title: 'Tron',
        icon: '/assets/images/partners/Tron.svg',
    },
    {
        title: 'Trust Wallet',
        icon: '/assets/images/partners/Trust Wallet.svg',
    },
    {
        title: 'UniSat',
        icon: '/assets/images/partners/UniSat.svg',
    },
    {
        title: 'Unstoppable',
        icon: '/assets/images/partners/Unstoppable.svg',
    },
    {
        title: 'USD Coin',
        icon: '/assets/images/partners/USD Coin.svg',
    },
    {
        title: 'Viction',
        icon: '/assets/images/partners/Viction.svg',
    },
    {
        title: 'XRP',
        icon: '/assets/images/partners/XRP.svg',
    },
    {
        title: 'Xverse',
        icon: '/assets/images/partners/Xverse.svg',
    },
]